import React from 'react';
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react';
import {Stack, Typography} from "@mui/material";

const CustomControlledEditor = ({errors, setErrors, data, setData, name, validators, title, ...rest}) => {
    const handleChange = (content) => {
        setData({...data, [name]: content});
    };

    const handleBlur = () => {
        const value = data[name] || '';
        for (let validator of validators[name]) {
            const {valid, error} = validator(value);
            if (!valid) {
                setErrors({...errors, [name]: error});
                break;
            } else setErrors({...errors, [name]: ''});
        }
    };

    return (
        <Stack spacing={2}>
            <Typography variant='h4'>{title}</Typography>
            <div style={{background: 'white', borderRadius: '2px'}}>
                <TinyMCEEditor
                    apiKey={process.env.REACT_APP_TINY_MCE}
                    value={data?.[name] || ''}
                    init={{
                        height: 500,
                        menubar: false,
                        plugins: [
                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                        ],
                        toolbar: 'undo redo | blocks | ' +
                            'bold italic forecolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat | help',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                    }}
                    onEditorChange={(content) => {
                        handleChange(content);
                        handleBlur();
                    }}
                    onBlur={handleBlur}
                    {...rest}
                />
            </div>
            {errors[name] && (
                <Typography color="error" variant="caption">
                    {errors[name]}
                </Typography>
            )}
        </Stack>
    );
};

export default CustomControlledEditor; 